<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "MainPage",
  data() {
    return {
      title: "home page",
      queryTag: this.$route.query.tag,
      queryFundraiser: this.$route.query.fundraiser,
      textQuery: this.$route.query,
    };
  },
  methods: {
    addQueryString(params) {
      history.pushState({}, null, this.$route.path + "?" + params);
    },
  },
  watch: {
    $route() {
      if (this.$route.query != undefined) {
        let queryText = new URLSearchParams(this.textQuery).toString();
        this.addQueryString(queryText);
      }
    },
  },
};
</script>
